import { createTheme } from '@mui/material/styles';
import { tokens } from './palette';

export const theme = createTheme({
  palette: {
    primary: {
      main: tokens.primary.main,
      dark: tokens.primary.dark,
      contrastText: tokens.text.onDark,
    },
    secondary: {
      main: tokens.secondary.main,
    },
    text: {
      primary: tokens.text.main,
      secondary: tokens.text.sub,
    },
    divider: tokens.border.light,
    background: {
      default: tokens.bg.base,
      paper: tokens.bg.base,
      soft: tokens.bg.soft,
      section: tokens.bg.section,
    },
  },

  custom: {
    border: tokens.border,
    bg: tokens.bg,
    text: tokens.text,
    secondary: tokens.secondary,
  },

  shape: { borderRadius: 12 },
});
